import React from 'react';
import { Lock, Check } from 'lucide-react';

const samplePhotoUrls = [
  'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=533&fit=crop',
  'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=533&fit=crop',
  'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=400&h=533&fit=crop',
  'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400&h=533&fit=crop',
  'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=400&h=533&fit=crop',
  'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=533&fit=crop',
];

const sampleProfiles = [
  { name: 'Riya (25, Mumbai)', tags: ['Friendly', 'Talkative', 'Traveler'], status: 'Available', blurred: true, photo: samplePhotoUrls[0], photoLocal: '/profile-samples/sample-1.jpg' },
  { name: 'Priya (26, Bangalore)', tags: ['Adventure', 'Music'], status: 'Available', blurred: true, photo: samplePhotoUrls[1], photoLocal: '/profile-samples/sample-2.jpg' },
  { name: 'Anjali (30, Pune)', tags: ['Yoga', 'Reading'], status: 'Available', verified: true, photo: samplePhotoUrls[2], photoLocal: '/profile-samples/sample-3.jpg' },
  { name: 'Neha (27, Hyderabad)', tags: ['Art', 'Music'], status: 'Available', blurred: true, photo: samplePhotoUrls[3], photoLocal: '/profile-samples/sample-4.jpg' },
  { name: 'Sara (28, Delhi)', tags: ['Travel', 'Fitness'], status: 'Available', blurred: true, photo: samplePhotoUrls[4], photoLocal: '/profile-samples/sample-5.jpg' },
  { name: 'Kavya (24, Chennai)', tags: ['Dance', 'Movies'], status: 'Available', blurred: true, photo: samplePhotoUrls[5], photoLocal: '/profile-samples/sample-6.jpg' },
];

const SampleProfiles = () => {
  return (
    <section className="py-16 md:py-24 bg-slate-900">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-heading font-bold text-2xl sm:text-3xl text-white text-center mb-4">
          Sample Profiles Preview
        </h2>
        <p className="text-slate-400 text-center mb-10 max-w-xl mx-auto">
          Only premium users can view full profile & chat
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {sampleProfiles.map((p, i) => (
            <div
              key={i}
              className={`rounded-2xl overflow-hidden bg-slate-800/80 border border-slate-700 ${
                p.verified ? 'ring-2 ring-brand-pink/40' : ''
              }`}
            >
              <div className="aspect-[3/4] relative bg-slate-800 overflow-hidden">
                <img
                  src={p.photo}
                  alt=""
                  onError={(e) => { e.target.onerror = null; e.target.src = p.photo; }}
                  className={`absolute inset-0 w-full h-full object-cover ${p.blurred ? 'blur-[20px] scale-110' : 'blur-[6px]'}`}
                />
                {p.blurred ? (
                  <>
                    <div className="absolute inset-0 bg-slate-900/40" />
                    <div className="absolute inset-0 flex items-center justify-center z-10">
                      <Lock className="h-10 w-10 text-brand-pink drop-shadow" />
                    </div>
                  </>
                ) : null}
                {p.verified && (
                  <div className="absolute top-2 right-2 w-8 h-8 rounded-full bg-brand-pink flex items-center justify-center">
                    <Check className="h-4 w-4 text-white" />
                  </div>
                )}
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-white">{p.name}</h3>
                <p className="text-xs text-slate-400 mt-1">{p.tags.join(' | ')}</p>
                <p className="text-sm text-emerald-400 mt-2">{p.status}</p>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-6 text-center text-slate-400 flex items-center justify-center gap-2">
          <Lock className="h-4 w-4 text-amber-400/90" />
          Only premium users can view full profile & chat
        </p>
      </div>
    </section>
  );
};

export default SampleProfiles;
